import React, { useState } from 'react'
import { data } from '../Assets/data';
import compucar from '../Assets/compucar.png'
import './Home.css'
import { motion, AnimatePresence } from "framer-motion"

const Home = () => {
    let [index, setIndex] = useState(0);
    let [question, setQuestion] = useState(data[index]);
    let [finished, setFinished] = useState(false);
    let [clicked, setClicked] = useState(0);
    let [attributes, setAttributes] = useState([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);
    let [array, setArray] = useState([]);

    const handleOptionClick = (value) => {
        attributes[index] = value;
        setAttributes(attributes);
        setIndex(++index);
        setQuestion(data[index]);

        if(index === 16){
            setFinished(true);
            fetchData();
        }

        setClicked(clicked + 1);
    };

    const fetchData = async () => {
        try {
          const response = await fetch('https://compucar-return-r3o2u.ondigitalocean.app/run-script', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ values: attributes}),
          });
      
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
      
          const output = await response.json();
          setArray([output.output[0], output.output[1], output.output[2], output.output[3], output.output[4], output.output[5],
                   output.output[6], output.output[7], output.output[8], output.output[9]]);
        } catch (error) {
          console.error('Error:', error);
        }
      };

    const rewind = () => {
        setIndex(0);
        setQuestion(data[0]);
        setFinished(false);
        setClicked(0);
        setAttributes([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);
    };

    // Calculate progress percentage
    const progress = (index / 16) * 100;

    // Animation variants for logo
    const logoVariants = {
        initial: { 
            opacity: 0, 
            y: -30,
            scale: 0.9
        },
        animate: { 
            opacity: 1, 
            y: 0,
            scale: 1,
            transition: {
                duration: 0.8,
                ease: [0.4, 0, 0.2, 1]
            }
        }
    };

    // Animation variants for questions
    const questionVariants = {
        initial: { 
            opacity: 0, 
            y: 20,
            scale: 0.96
        },
        animate: { 
            opacity: 1, 
            y: 0,
            scale: 1,
            transition: {
                duration: 0.5,
                ease: [0.4, 0, 0.2, 1]
            }
        },
        exit: { 
            opacity: 0, 
            y: -20,
            scale: 0.96,
            transition: {
                duration: 0.3
            }
        }
    };

    // Animation variants for options
    const optionVariants = {
        initial: { 
            opacity: 0, 
            x: -15
        },
        animate: (custom) => ({ 
            opacity: 1, 
            x: 0,
            transition: {
                delay: custom * 0.12,
                duration: 0.5,
                ease: [0.4, 0, 0.2, 1]
            }
        }),
        hover: {
            y: -3,
            transition: {
                duration: 0.2
            }
        },
        tap: {
            y: -1,
            scale: 0.98
        }
    };

    // Animation variants for results
    const resultVariants = {
        initial: { 
            opacity: 0, 
            scale: 0.94,
            y: 15
        },
        animate: (custom) => ({ 
            opacity: 1, 
            scale: 1,
            y: 0,
            transition: {
                delay: custom * 0.06,
                duration: 0.4,
                ease: [0.4, 0, 0.2, 1]
            }
        })
    };

    return (
        <div className='Home'>
            <div className='home-content'>
                {/* LOGO SECTION - ALWAYS VISIBLE */}
                <motion.div 
                    className="logo-section"
                    variants={logoVariants}
                    initial="initial"
                    animate="animate"
                >
                    <div className="logo-container">
                        <motion.img 
                            src={compucar} 
                            alt="CompuCar"
                            whileHover={{ 
                                y: -5,
                                transition: { duration: 0.3 }
                            }}
                        />
                    </div>
                    <motion.div 
                        className="tagline"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.4, duration: 0.8 }}
                    >
                        Find Your Perfect Match
                    </motion.div>
                </motion.div>

                {/* QUIZ OR RESULTS SECTION */}
                {finished ? (
                    // RESULTS VIEW
                    <div className='results-section'>
                        <motion.h3
                            className="results-title"
                            initial={{ opacity: 0, y: -15 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
                        >
                            Your Perfect Matches
                        </motion.h3>

                        <ul className="results-list">
                            {array.map((car, idx) => (
                                <motion.li
                                    key={idx}
                                    className="result-card"
                                    custom={idx}
                                    variants={resultVariants}
                                    initial="initial"
                                    animate="animate"
                                >
                                    {car}
                                </motion.li>
                            ))}
                        </ul>
                        
                        <motion.button
                            className="restart-button"
                            onClick={rewind}
                            initial={{ opacity: 0, y: 15 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.6, duration: 0.4 }}
                            whileHover={{ y: -3 }}
                            whileTap={{ y: -1, scale: 0.98 }}
                        >
                            Start Over
                        </motion.button>
                    </div>
                ) : (
                    // QUIZ VIEW
                    <div className='quiz-section'>
                        {/* Question Card */}
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={clicked}
                                className="question-card"
                                variants={questionVariants}
                                initial="initial"
                                animate="animate"
                                exit="exit"
                            >
                                {question.question}
                            </motion.div>
                        </AnimatePresence>

                        {/* Progress Bar */}
                        <div className="progress-bar-container">
                            <motion.div 
                                className="progress-bar"
                                initial={{ width: 0 }}
                                animate={{ width: `${progress}%` }}
                                transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
                            />
                        </div>

                        {/* Options */}
                        <ul className="options-list">
                            <AnimatePresence mode="wait">
                                {[
                                    { text: question.option1, value: 0 },
                                    { text: question.option2, value: 2 },
                                    { text: question.option3, value: 4 },
                                    { text: question.option4, value: 6 },
                                    { text: question.option5, value: 8 },
                                    { text: question.option6, value: 10 }
                                ].map((option, idx) => (
                                    <motion.li
                                        key={`${clicked}-${idx}`}
                                        className="option-button"
                                        custom={idx}
                                        variants={optionVariants}
                                        initial="initial"
                                        animate="animate"
                                        whileHover="hover"
                                        whileTap="tap"
                                        onClick={() => handleOptionClick(option.value)}
                                    >
                                        {option.text}
                                    </motion.li>
                                ))}
                            </AnimatePresence>
                        </ul>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Home